
import { AuthPermIdentifier } from "@myapp/modules/fwcore/models";
import { RequestBase, RequestBaseSet } from "@myapp/modules/fwcore/models/messages/request-base";
import { ResponseBase, ResponseBasePage } from "@myapp/modules/fwcore/models/messages/response-base";

export class RequestRolePerm extends RequestBase {

  roleId?: string | null;
  licenseId?: string | null;
  hierarchyId?: string | null;
  authTypes?: string[] | null;
}

export class RequestRolePermSet extends RequestBaseSet<AuthPermIdentifier>
{
  roleId?: string | null;
  licenseId?: string | null;
  hierarchyId?: string | null;
  authTypes?: string[] | null;
}

export class ResponseRolePerm extends ResponseBasePage<AuthPermIdentifier> {

}


export class ResponseRolePermSet extends ResponseBase {

}
